<div class="filtering">
    <span class="drg-icon_user"></span>
    <div class="group-select filtering" *ngIf="showFiltering$ | async">
        <ng-container *ngIf="!hideFirstLevelFiltering">
            <ng-container class="bussines-field" *ngIf="categories$ | async as categories">
                <ng-container>
                    <div class="bussines-field">
                        <div class="select" [class.active]="hasFocus">
                            <span class="labelcontent fixed" [innerHTML]="filterName"></span>
                            <div [class.disabled]="(disablingBusinessField$ | async) && !isUserPage" class="select-wrapper">
                                <select
                                    [disabled]="(disablingBusinessField$ | async) && !isUserPage"
                                    (focus)="hasFocus = true"
                                    (blur)="hasFocus = false"
                                    #s="ngModel"
                                    (change)="onSelectDivisions(s.value, true)"
                                    [(ngModel)]="selectedValue"
                                >
                                    <option *ngFor="let cat of categories" [ngValue]="cat.id">{{ cat.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
        <div class="inner-filtering">
            <ng-container *ngIf="showSecondLevelFiltering">
                <ng-container *ngIf="subCategories$ | async as subCategories">
                    <div>
                        <div class="select" [class.active]="hasFocusSubCat">
                            <span class="labelcontent fixed" [innerHTML]="'common.filteringDropdownTrainingSegments' | translate"></span>
                            <div class="select-wrapper" [class.disabled]="subCategories.length <= 1">
                                <select
                                    (focus)="hasFocusSubCat = true"
                                    (blur)="hasFocusSubCat = false"
                                    [disabled]="subCategories.length <= 1"
                                    #s="ngModel"
                                    (change)="onSelectSubCat(s.value, true)"
                                    [(ngModel)]="selectedValueSubCat"
                                >
                                    <option *ngFor="let cat of subCategories" [ngValue]="cat.name">{{ cat.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="showSecondLevelFiltering && showThirdLevelFiltering">
                <ng-container *ngIf="subSubCategories$ | async as subSubCategories">
                    <div>
                        <div class="select" [class.active]="hasFocusSubSubCat">
                            <span class="labelcontent fixed" [innerHTML]="'common.filteringDropdownProductAreas' | translate"></span>
                            <div class="select-wrapper" [class.disabled]="subSubCategories.length <= 1 || !hasCourses">
                                <select
                                    (focus)="hasFocusSubSubCat = true"
                                    (blur)="hasFocusSubSubCat = false"
                                    [disabled]="subSubCategories.length <= 1 || !hasCourses"
                                    #s="ngModel"
                                    (change)="onSelectSubSubCat(s.value)"
                                    [(ngModel)]="selectedValueSubSubCat"
                                >
                                    <option *ngFor="let cat of subSubCategories" [ngValue]="cat.name">{{ cat.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container>
                <da-acs-input
                    *ngIf="showTitleSearch"
                    (titleValue)="valuechange($event)"
                    [title]="title"
                    [coursesByTitle]="coursesByTitle"
                ></da-acs-input>
            </ng-container>
        </div>
    </div>
    <div class="group-select small" *ngIf="!(showFiltering$ | async)">
        <ng-container class="busines-field">
            <ng-container>
                <div>
                    <div class="select" [class.active]="hasFocus">
                        <span class="labelcontent fixed" [innerHTML]="filterName"></span>
                        <div [class.disabled]="(disablingBusinessField$ | async) && !isUserPage" class="select-wrapper">
                            <select
                                (focus)="hasFocus = true"
                                (blur)="hasFocus = false"
                                [disabled]="(disablingBusinessField$ | async) && !isUserPage"
                                #s="ngModel"
                                (change)="onSelectDivisions(s.value, true)"
                                [(ngModel)]="selectedValue"
                            >
                                <option *ngFor="let cat of categories" [ngValue]="cat.id">{{ cat.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="showSecondLevelFiltering">
                <ng-container *ngIf="subCategories$ | async as subCategories">
                    <div>
                        <div class="select" [class.active]="hasFocusSubCat">
                            <span class="labelcontent fixed" [innerHTML]="'common.filteringDropdownTrainingSegments' | translate"></span>
                            <div class="select-wrapper" [class.disabled]="subCategories.length <= 1">
                                <select
                                    (focus)="hasFocusSubCat = true"
                                    (blur)="hasFocusSubCat = false"
                                    [disabled]="subCategories.length <= 1"
                                    #s="ngModel"
                                    (change)="onSelectSubCat(s.value, true)"
                                    [(ngModel)]="selectedValueSubCat"
                                >
                                    <option *ngFor="let cat of subCategories" [ngValue]="cat.name">{{ cat.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="showSecondLevelFiltering && showThirdLevelFiltering">
                <ng-container *ngIf="subSubCategories$ | async as subSubCategories">
                    <div>
                        <div class="select" [class.active]="hasFocusSubSubCat">
                            <span class="labelcontent fixed" [innerHTML]="'common.filteringDropdownProductAreas' | translate"></span>
                            <div class="select-wrapper" [class.disabled]="subSubCategories.length <= 1 || !hasCourses">
                                <select
                                    (focus)="hasFocusSubSubCat = true"
                                    (blur)="hasFocusSubSubCat = false"
                                    [disabled]="subSubCategories.length <= 1 || !hasCourses"
                                    #s="ngModel"
                                    (change)="onSelectSubSubCat(s.value)"
                                    [(ngModel)]="selectedValueSubSubCat"
                                >
                                    <option *ngFor="let cat of subSubCategories" [ngValue]="cat.name">{{ cat.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</div>
